export default "__VITE_ASSET__B_kU4jIC__"